import { HomepageHeroProps } from 'libs/contentful/props';
import HomepageHeroCenteredVariant from './HomepageHeroCenteredVariant';
import HomepageHeroTwoColumnVariant from './HomepageHeroTwoColumnVariant';

export enum HomepageHeroVariants {
  Centered = 'Centered',
  TwoColumn = 'Two Column',
}

const HomepageHero = (props: HomepageHeroProps) => {
  const { variant } = props;

  switch (variant) {
    case HomepageHeroVariants.Centered:
      return <HomepageHeroCenteredVariant {...props} />;
    case HomepageHeroVariants.TwoColumn:
      return <HomepageHeroTwoColumnVariant {...props} />;
    default:
      return null;
  }
};

export default HomepageHero;
